import { createAction } from 'redux-actions'

const ns = 'signup/'

export const doSignUp = createAction(`${ns}DO_SIGN_UP`)
